import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { API_ENDPOINTS } from "../config/api";

const DelegationsContext = createContext(null);

export function useDelegations() {
  const ctx = useContext(DelegationsContext);
  if (!ctx) throw new Error("useDelegations must be used within DelegationsProvider");
  return ctx;
}

export const DelegationsProvider = ({ children }) => {
  const [activeDelegations, setActiveDelegations] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const activeModuleKeys = useMemo(() => {
    return new Set(activeDelegations.map((d) => d.moduleKey));
  }, [activeDelegations]);

  const refreshActiveDelegations = async () => {
    if (!token) {
      setActiveDelegations([]);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_ENDPOINTS.DELEGATIONS}/active/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        setActiveDelegations([]);
        return;
      }
      const data = await res.json();
      setActiveDelegations(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Failed to fetch active delegations:", e);
      setActiveDelegations([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshActiveDelegations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasModuleAccess = (moduleKey) => activeModuleKeys.has(moduleKey);

  const value = {
    activeDelegations,
    activeModuleKeys,
    hasModuleAccess,
    loading,
    refreshActiveDelegations,
  };

  return <DelegationsContext.Provider value={value}>{children}</DelegationsContext.Provider>;
};

